const { colors } = require('./../../tailwind');

module.exports = {
  't-h1': {
    color: colors.grayDarkMedium,
    fontSize: 32,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-h2': {
    color: colors.grayDarkMedium,
    fontSize: 28,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-h3': {
    color: colors.grayDarkMedium,
    fontSize: 24,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-h4': {
    color: colors.grayDarkMedium,
    fontSize: 22,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-h4x': {
    color: colors.grayDarkMedium,
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-h5': {
    color: colors.grayDarkMedium,
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-h6': {
    color: colors.grayDarkMedium,
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-h7': {
    color: colors.grayDarkMedium,
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
  't-xl': { color: colors.grayDarkMedium, fontSize: 36 },
  't-lxxx': { color: colors.grayDarkMedium, fontSize: 28 },
  't-lxx': { color: colors.grayDarkMedium, fontSize: 22 },
  't-lx': { color: colors.grayDarkMedium, fontSize: 18 },
  't-l': { color: colors.grayDarkMedium, fontSize: 16 },
  t: {
    color: colors.grayDarkMedium,
    fontSize: 16,
    fontFamily: 'Metropolis',
    fontWeight: 300,
  },
  't-m': { color: colors.grayDarkMedium, fontSize: 14 },
  't-s': { color: colors.grayDarkMedium, fontSize: 12 },
  't-sx': { color: colors.grayDarkMedium, fontSize: 10 },
  't-sxx': { color: colors.grayDarkMedium, fontSize: 8 },
  't-sxxx': { color: colors.grayDarkMedium, fontSize: 6 },
  't-align-center': { textAlign: 'center' },
  't-align-right': { textAlign: 'right' },
};



// WEBPACK FOOTER //
// ./src/helpers/styleDefs/fontSizeStyles.js